import type { Dispatch, SetStateAction } from "react";
import { type RadioGroupProps, RadioSelector } from "~/components/form/radio/RadioSelector";

export type YesNoProps = {
    value?: boolean | null;
    onValueChange?: ((value: boolean) => void) | Dispatch<SetStateAction<boolean>>;
} & Omit<RadioGroupProps, "value" | "onValueChange" | "options">;

const Yes = "Yes";
const No = "No";
type YesNoOption = typeof Yes | typeof No;
const YesNoOptions: YesNoOption[] = [Yes, No];

export const YesNo = ({ value, onValueChange, columns = 2, ...radioProps }: YesNoProps) => {
    const mapped = (value && Yes) || (value === false && No) || null;
    const setValue = (selected: YesNoOption) => {
        onValueChange?.({ [Yes]: true, [No]: false }[selected]);
    };

    return (
        <RadioSelector
            {...radioProps}
            options={YesNoOptions}
            value={mapped}
            onValueChange={setValue}
            columns={columns}
        />
    );
};
